import { Tooltip } from '@mantine/core';

export { type FloatingPosition, Tooltip, type TooltipProps } from '@mantine/core';

export default Tooltip;
